/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="#333" fillRule="evenodd">
      <path d="M133.93 214.086l83.567-126.555c1.555-2.296 1.667-5.258.37-7.702-1.37-2.406-3.887-3.961-6.627-3.961h-70.165a7.453 7.453 0 00-5.924 2.962C45.326 195.092 20.814 265.33 14.15 299.69a80.197 80.197 0 00-1.037 5.185v.074c-1.333 8.293-1.814 13.996-1.74 17.106 0 .851-.26 1.629-.26 2.443v.074c0 61.612 49.986 111.597 111.597 111.597 29.473 0 56.095-11.663 76.052-30.324.889-.852 2-1.481 2.851-2.37a114.382 114.382 0 0013.663-16.513c12.033-17.81 19.068-39.285 19.068-62.39 0-57.797-44.098-104.784-100.415-110.486M501.977 324.554c0-57.798-44.061-104.747-100.378-110.45L485.167 87.55c1.555-2.332 1.666-5.257.37-7.701-1.333-2.444-3.888-3.962-6.627-3.962h-70.128c-2.37 0-4.517 1.074-5.961 2.925-89.53 115.892-114.152 185.983-120.928 220.491-.444 2-.814 3.999-1.185 6.035-1.258 7.924-1.74 13.478-1.666 16.551-.037.926-.259 1.777-.259 2.666 0 35.027 16.477 65.907 41.729 86.382 19.18 15.514 43.283 25.215 69.868 25.215 61.649 0 111.597-49.948 111.597-111.597z" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconDmResponse = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconDmResponse.defaultProps = {
  theme,
};
IconDmResponse.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconDmResponse.displayName = 'IconDmResponse';
export { IconDmResponse };
